import {
  Box,
  Divider,
  Flex,
  Heading,
} from "@chakra-ui/react";
import { useState } from "react";
import { useFormContext } from "react-hook-form";
import AllowHumanHandover from "../../Assistants/AllowHumanHandover";
import ConversationFields from "../../Assistants/ConversationFields";
import LLMrelated from "../../Assistants/LLMrelated";
import Prompt from "../../Assistants/Prompt";
import VoicesField from "../../Assistants/VoicesField";

const LogicTab = ({ languages, voices, getVoices, myownVoiceOptions, member }) => {
  const { watch } = useFormContext();
  const assistantType = watch("assistant_type");
  const isVoice = assistantType === "phone" || assistantType === "realtime_openai";

  const [promptType, setPromptType] = useState("");

  return (
    <Flex direction="column" gap={6}>
      {/* Agent Architecture */}
      <Box>
        <Heading size="xs" mb={3} color="gray.600" textTransform="uppercase" letterSpacing={1}>
          Agent Architecture
        </Heading>
        <ConversationFields member={member} />
      </Box>

      <Divider />

      {/* AI Model */}
      <Box>
        <Heading size="xs" mb={3} color="gray.600" textTransform="uppercase" letterSpacing={1}>
          AI Model
        </Heading>
        <LLMrelated promptType={promptType} setPromptType={setPromptType} />
      </Box>

      <Divider />

      {/* System Prompt */}
      <Box>
        <Heading size="xs" mb={3} color="gray.600" textTransform="uppercase" letterSpacing={1}>
          System Prompt
        </Heading>
        <Prompt promptType={promptType} />
      </Box>

      {/* Voice Settings — voice assistants only */}
      {isVoice && (
        <>
          <Divider />
          <Box>
            <Heading size="xs" mb={3} color="gray.600" textTransform="uppercase" letterSpacing={1}>
              Voice Settings
            </Heading>
            <VoicesField
              languages={languages}
              voices={voices}
              getVoices={getVoices}
              myownVoiceOptions={myownVoiceOptions}
            />
          </Box>
        </>
      )}

      <Divider />

      {/* Human Handover */}
      <Box>
        <Heading size="xs" mb={3} color="gray.600" textTransform="uppercase" letterSpacing={1}>
          Handover
        </Heading>
        <AllowHumanHandover member={member} />
      </Box>
    </Flex>
  );
};

export default LogicTab;
